// Angular imports
import { Component, Input, OnInit } from '@angular/core';

// Common imports
import { Utils } from 'cc-common';

// Service imports
import { CiraHelpService } from '../../../_services/shared-services/cira-help.service';

@Component({
    selector: 'app-workflow-status-link',
    templateUrl: './workflow-status-link.component.html',
    styleUrls: ['./workflow-status-link.component.scss']
})
export class WorkflowStatusLinkComponent implements OnInit {
    @Input() status: string;

    helpLink: string;

    constructor(private readonly ciraHelpService: CiraHelpService) {}

    ngOnInit() {
        this.helpLink = this.ciraHelpService.getHelpLinkByKey(`WFSTATUS_${this.status.toUpperCase()}`);
    }

    onStatusClick(): void {
        if (Utils.notNullOrEmpty(this.helpLink)) {
            window.open(this.helpLink, '_blank');
        }
    }
}
